import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=6545ac00"
import script from "./PaymentsTable.vue?vue&type=script&lang=js"
export * from "./PaymentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports